import React from 'react';
import RecentChanges from '../components/RecentChanges';

const RecentChangesPage = () => {
  return <RecentChanges />;
};

export default RecentChangesPage;
